export default __webpack_public_path__ + "static/media/pickles.611bbe36.png";